// This file contains reusable validation functions.

export const isValidIndianPhoneNumber = (phone) => {
  if (!phone) return true; // It's valid if it's empty, we check for requirement separately
  const phoneRegex = /^[6-9]\d{9}$/;
  return phoneRegex.test(phone);
};

export const isValidEmail = (email) => {
  if (!email) return true; // Valid if empty
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
